import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { LoadingScreen } from "../components/LoadingScreen";
import { useAuth } from "../lib/auth";
import type { UserRole } from "../lib/api";
import { getValidatedSignInReturnTo } from "../features/auth/provider-return-to";

export function ProtectedRoute({
  children,
  allow,
}: {
  children: ReactNode;
  allow: (role: UserRole) => boolean;
}) {
  const { homePath, status, user } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <LoadingScreen />;
  }

  if (status === "anonymous" || !user) {
    const returnTo = getValidatedSignInReturnTo(`${location.pathname}${location.search}`);
    return <Navigate replace to={returnTo ? `/sign-in?returnTo=${encodeURIComponent(returnTo)}` : "/sign-in"} />;
  }

  if (!allow(user.role)) {
    return <Navigate replace to={homePath} />;
  }

  return <>{children}</>;
}
